<script>
import mapboxgl from 'mapbox-gl';

export default {
	props: {
		accessToken: {
            type: String,
            default: process.env.MIX_MAPBOXGL_ACCESS_TOKEN,
        },
        mapId: {
            type: String,
            required: true,
        },
        mapStyle: {
            type: String,
            default: process.env.MIX_MAPBOXGL_STYLE,
        },
        mapSprite: {
            type: String,
            default: 'satellite-v9',
        },
        mapZoom: {
            type: Number,
            default: 16,
        },
        minZoom: {
            type: Number,
            default: 0,
        },
        maxZoom: {
            type: Number,
            default: 24,
        },
        pitchWithRotate: {
            type: Boolean,
            default: false,
        },
        dragRotate: {
            type: Boolean,
            default: false,
        },
        scrollZoom: {
            type: Boolean,
            default: true,
        },
        center: {
            type: Array,
            default: [0, 0],
        },
        touchZoomRotate: {
            type: Boolean,
            default: false,
        },
        maxBounds: {
            type: [Boolean, Array],
            default: false,
        },
        reset: {
            type: Boolean,
            default: false,
        }
	},
	data() {
        return {
            map: null,
            loaded: false,
        };
	},
	mounted() {
        //this.$el.style.height = `${this.$el.parentNode.getBoundingClientRect().height}px`;

        this.map = new mapboxgl.Map({
            container: this.mapId,
            style: this.mapStyle,
            sprite: `mapbox://sprites/mapbox/${this.mapSprite}`,
            zoom: this.mapZoom,
            minZoom: this.minZoom,
            maxZoom: this.maxZoom,
            center: this.center,
            pitchWithRotate: this.pitchWithRotate,
            dragRotate: this.dragRotate,
            scrollZoom: this.scrollZoom,
            accessToken: this.accessToken,
        });

        if (this.maxBounds) this.map.maxBounds = this.maxBounds;

        // disable rotate on touch devices
        if (!this.touchZoomRotate) this.map.touchZoomRotate.disableRotation();

        this.map.on('load', () => {
            this.loaded = true;
            this.$emit('map-loaded', this.map)
        });

    },
    computed: {
        currentZoom() {
            let zoom = this.mapZoom;
            if (this.loaded) {
               zoom = this.map.getZoom();
            }
            return zoom;
        },
        currentCenter() {
            let center = this.center;
            if (this.loaded) {
                center = this.map.getCenter();
            }
            return center;
        },
    },
    watch: {
        reset(newValue) {
            if (newValue) {
                this.map.jumpTo({
                    center: this.center,
                    zoom: this.mapZoom,
                });

                this.$emit('map-reset', this.map);
            }
        },
    },
};
</script>

<template>
  <div :id="mapId" :class="$style.map">
    <slot />
  </div>
</template>

<style lang="scss" module>
.map {
  min-height: 300px;

  :global {
    canvas {
      left: 0;
    }
  }
}
</style>
